import { Component, Input, OnInit, inject } from "@angular/core";
import { PropPropertyAttribute } from "@app/integrations/urm/models/prop-property-attribute";
import { PropPropertyAttributeCode } from "@app/integrations/urm/models/prop-property-attribute-code";
import { CautionService } from "@app/integrations/urm/services/caution.service";
import { TextAnonymisationBehaviour } from "@app/integrations/urm/models/prop-tenant-attribute-code";
import { MatListItem } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: "urm-property-caution-list-item",
  templateUrl: "./property-caution-list-item.component.html",
  styleUrls: ["./property-caution-list-item.component.css"],
  imports: [MatListItem, MatIcon, MatTooltip]
})
export class PropertyCautionListItemComponent implements OnInit {
  protected cautionService = inject(CautionService);

  @Input()
  public caution: PropPropertyAttribute;
  public cautionCode: PropPropertyAttributeCode;
  public topText: string;
  public hiddenFromOperative: boolean;
  public loading: boolean = true;

  ngOnInit() {
    if (!this.caution) return;

    this.cautionService
      .propertyAttributeCodeLookup(this.caution.Attb_AttributeCodeID)
      .then((value) => {
        console.log("assigning caution code to attribute");
        this.cautionCode = value;
        this.loading = false;
        this.topText = value.Attc_Description;
        this.hiddenFromOperative =
          value.Attc_TextAnonymisationBehaviour ===
          TextAnonymisationBehaviour.AlternateText;
      });
  }
}
